'use client'

import { HTMLAttributes } from 'react'
import clsx from 'classnames'
import Image from 'next/image'
import { motion } from 'framer-motion'
import { Text } from '@/shared/ui'
import { useAppearance, variantsDefault } from '@/shared/utils'
import ArrowUpRightIcon from '@/public/arrow-up-right.svg'
import { IBanner } from '@/interfaces/banner'
import style from './second-event.module.scss'

interface SecondEventProps extends HTMLAttributes<HTMLDivElement> {
  banner: IBanner | null
}

export const SecondEvent = (props: SecondEventProps) => {
  const { className, banner } = props
  const { ref: articleRef, animate: articleAnimate } = useAppearance()

  return (
    <motion.a
      ref={articleRef}
      className={clsx(style.container, className)}
      initial="hidden"
      animate={articleAnimate}
      variants={variantsDefault}
      href={banner?.url}
      target="__blank"
    >
      <Image className={style.image} src={banner?.image.url ?? ''} alt="second-event" fill />
      <Text tagName="span" type="l1" color="white" className={style.heading}>
        {banner?.title}
      </Text>
      <div className={style.wrapper}>
        <div
          className={clsx('text', 'text_type_t1', 'text_color_white')}
          dangerouslySetInnerHTML={{ __html: banner?.description ?? '' }}
        />
      </div>
      <ArrowUpRightIcon className={style.link} />
    </motion.a>
  )
}
